// @flow

const initialState = {
  entityId: null,
  isOpen: false,
  mediaId: null,
  attachments: null,
};

export default function shortnerGallery(state = initialState, action) {
  switch (action.type) {
    case 'SHOW_SHORTNER_GALLERY':
      return {
        entityId: action.entityId,
        isOpen: true,
        mediaId: action.mediaId,
        attachments: action.attachments,
      };

    case 'HIDE_SHORTNER_GALLERY':
      return initialState;

    default:
      return state;
  }
}
